import { z } from 'zod/v4';

export const TagEntityDTO = z.enum(['dashboards', 'queries']);
export type TagEntity = z.infer<typeof TagEntityDTO>;

export const SRMTagDTO = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
  count: z.number(),
});
export type SRMTag = z.infer<typeof SRMTagDTO>;

export const TagListResponseDTO = z.object({
  name: z.string(),
  color: z.string(),
  id: z.string(),
  queries: z.number(),
  dashboards: z.number(),
});
export type TagListResponse = z.infer<typeof TagListResponseDTO>;

export const TagCreateResponseDTO = z.object({
  name: z.string(),
  color: z.string(),
  id: z.string(),
});
export type TagCreateResponse = z.infer<typeof TagCreateResponseDTO>;

export const TagRequestDTO = z.object({
  name: z.string(),
  color: z.string(),
});
export type TagRequest = z.infer<typeof TagRequestDTO>;

export const TagResponseDTO = z.object({
  name: z.string(),
  color: z.string(),
  id: z.string(),
  queries: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  dashboards: z.array(z.any()),
});
export type TagResponse = z.infer<typeof TagResponseDTO>;

export const TagSimpleResponseDTO = z.object({
  id: z.string(),
  name: z.string(),
  color: z.string(),
});
export type TagSimpleResponse = z.infer<typeof TagSimpleResponseDTO>;

export const TagUpdateRequestDTO = z.object({
  name: z.string().optional(),
  color: z.string().optional(),
});
export type TagUpdateRequest = z.infer<typeof TagUpdateRequestDTO>;

export const TagWithIdResponseDTO = z.object({
  name: z.string(),
  color: z.string(),
  id: z.string(),
});
export type TagWithIdResponse = z.infer<typeof TagWithIdResponseDTO>;